import React, { ReactNode } from "react";
import {
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "@heroui/react";

interface CommonModalProps {
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
    title?: string | ReactNode;
    children: ReactNode;
    footer?: ReactNode;
    size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl";
    placement?: "center" | "top" | "bottom";
    closeButton?: boolean;
    headerClassName?: string;
}

const CommonModal: React.FC<CommonModalProps> = ({isOpen, onOpenChange, title, children, footer, size = "md", placement = "center", closeButton = true, headerClassName=""}) => {
    return (
        <Modal
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            size={size}
            placement={placement}
            closeButton={closeButton}
            isDismissable={false}
        >
            <ModalContent>
                {onClose => (
                    <>
                        {title && (
                            <ModalHeader className={`text-center text-xl font-bold text-gray-900 p-6 ${headerClassName}`}>
                                {title}
                            </ModalHeader>
                        )}
                        <ModalBody className="px-6 pb-6 pt-0">{children}</ModalBody>
                        {footer && <ModalFooter>{footer}</ModalFooter>}
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};

export default CommonModal;
